import React, { useState } from "react";
import styles from "./MammalChampion.module.scss";
import JoinComponent from "./JoinComponent";
import { Link } from "@reach/router";
import Username from "./Username";

function BirdChampion(props) {
  const [birdNo, setBirdNo] = React.useState(0);

  if (birdNo === 0) {
    return (
      <div className={styles.bkg}>
        <p>
          You decided to go and click a random button that you didn't know what
          it did. Good job! It knocked you out, and moved you to a different
          room. You can barely see ahead of yourself, and then you hear a
          high-pitched noise at the end of said room.
        </p>
        <p>Do you:</p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setBirdNo(2);
          }}
        >
          Investigate
        </button>
        &nbsp;
        <button
          className={styles.choice}
          onClick={(event) => {
            setBirdNo(1);
          }}
        >
          Be a coward
        </button>
        <br />
        <JoinComponent folk={props.type} alpha={props.alpha} />
      </div>
    );
  }
  if (birdNo === 1) {
    return (
      <div className={styles.bkg}>
        <p>
          You decided to run off. That is until you run into a wall, and are
          forced to choose another Folk... You need to be brave to earn your
          wings kiddo.
        </p>
      </div>
    );
  }
  if (birdNo === 2) {
    return (
      <div className={styles.bkg}>
        <p>
          With great caution you start to take a step forward, then another. You
          can feel the adrenaline rushing through you. As you draw closer, you
          don't see much. Then, you see something. At first, it is only a blob
          in the never ending darkness, but as you move forward, still with that
          sense of dread, you identify it. A bird. No, a Pigeon!
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(3);
            }}
          >
            Approach the Pigeon
          </button>
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(1);
            }}
          >
            Be a Coward{" "}
          </button>
        </p>
      </div>
    );
  }
  if (birdNo === 3) {
    return (
      <div className={styles.bkg}>
        <p>
          The Pigeon responds: "Hey. I see you have chosen the bird folk. Good
          choice." It takes you a second to understand who is talking. "Who is
          there?" you ask, with a touch of caution in your voice. "Why do people
          never understand? I am THE Pigeon. The CHAMPION of the Bird Folk."
          <br />
          <br /> Do you:
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(4);
            }}
          >
            Inquire who the bird folk are{" "}
          </button>
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(6);
            }}
          >
            Go and meet some other folk{" "}
          </button>
        </p>
      </div>
    );
  }
  if (birdNo === 4) {
    return (
      <div className={styles.bkg}>
        <p>
          "Ah. I thought it would be easy to make sense of that. We the Bird
          Folk are the collective category of "Birds". With a snap of its
          talons, you notice that the whole room you are in lights up. You are
          surrounded by birds of all species. The Pigeon Champion looks at you,
          gesturing to walk with him while examining the shady, intimidating,
          dangerous birds.
          <br />
          <br />
          Do you:
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(5);
            }}
          >
            {" "}
            Walk with the Pigeon Champion
          </button>
          <button
            className={styles.choice}
            onClick={(event) => {
              setBirdNo(1);
            }}
          >
            {" "}
            Be a coward
          </button>
        </p>
      </div>
    );
  }
  if (birdNo === 5) {
    return (
      <div className={styles.bkg}>
        <p>
          “Birds have a raw deal in Liverpool. Join our folk to help us show
          humans how things affect us by leaving markers for incidents you
          notice in the city" explained the Pigeon. A few of my fellow birds
          haven't reported to us in a while. Your FIRST MISSION would be to
          locate them: Please help me find in the map the Owl, the Seagull and
          the Blackbird. They may help you understand how you can support our
          feathery cause." You feel excited about the prospect of being useful
          to your folk.
        </p>

        <p>
          "So now it's time we push you off the nest... Are you ready?" The
          Pigeon asks.
        </p>
        <button
          className={styles.choice}
          onClick={(event) => {
            setBirdNo(1);
          }}
        >
          Be a Coward
        </button>
        <button
          className={styles.choice}
          onClick={(event) => {
            setBirdNo(7);
          }}
        >
          Join the Bird Folk{" "}
        </button>
      </div>
    );
  }

  if (birdNo === 6) {
    return (
      <div className={styles.bkg}>
        >
        <p>
          "Never mind... The secret of the skies and the language of the wind
          are too much for you to handle. Now, leave. Talk to some other Folk"
          said the Pigeon as you are dismissed.
        </p>
      </div>
    );
  }
  if (birdNo === 7) {
    return (
      <div className={styles.bkg}>
        <p>
          <Link className={styles.choice} to={"/" + props.type + ""}>
            Enter as one of the Bird Folk
          </Link>
        </p>
      </div>
    );
  }
}

export default BirdChampion;
